import { http, HttpResponse } from 'msw';

export const plaidHandlers = [
  // plaidLinkInfoId for redirect to Plaid
  http.post('*/ajax/plaidLinkInit', () => {
    return HttpResponse.json({ plaidLinkInfoId: '9990222' }, { status: 200 });
  }),
];
